<!-- Burbuja flotante Aguacatico (solo visible para operadores autorizados) -->
<div class="agent-widget-container" *ngIf="isVisible">
  <!-- Panel de chat desplegable -->
  <div class="agent-chat-panel" *ngIf="isOpen">
    <!-- Header del chat -->
    <div class="agent-chat-header">
      <div class="header-left">
        <img src="assets/img/aguacatebot.png" alt="Aguacatico" class="agent-avatar" />
        <div>
          <h3 class="header-title">Aguacatico AI</h3>
          <span class="header-status" *ngIf="!ctrl.isStreaming">En linea</span>
          <span class="header-status streaming" *ngIf="ctrl.isStreaming">
            <span class="dot-pulse"></span>
            {{ ctrl.currentToolName ? 'Consultando ' + formatToolName(ctrl.currentToolName) : 'Escribiendo...' }}
          </span>
        </div>
      </div>
      <div class="header-actions">
        <button
          class="header-btn"
          [class.active]="deepMode"
          (click)="toggleDeepMode()"
          [title]="deepMode ? 'Modo análisis profundo activo' : 'Activar análisis profundo'"
          [disabled]="ctrl.isStreaming"
        >
          <mat-icon>{{ deepMode ? 'psychology_alt' : 'psychology' }}</mat-icon>
        </button>
        <button class="header-btn" (click)="showConversationList = !showConversationList" title="Conversaciones">
          <mat-icon>forum</mat-icon>
        </button>
        <button class="header-btn" (click)="newConversation()" title="Nueva conversacion">
          <mat-icon>add_circle_outline</mat-icon>
        </button>
        <button class="header-btn" (click)="toggleChat()" title="Cerrar">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Lista de conversaciones (dropdown) -->
    <div class="conversations-dropdown" *ngIf="showConversationList">
      <div
        *ngFor="let conv of ctrl.conversations"
        class="conv-item"
        [class.active]="ctrl.currentConversation?.id === conv.id"
        (click)="selectConversation(conv)"
      >
        <mat-icon class="conv-icon">chat_bubble_outline</mat-icon>
        <div class="conv-info">
          <span class="conv-title">{{ conv.title || 'Sin titulo' }}</span>
          <span class="conv-meta">{{ conv.messageCount }} msgs</span>
        </div>
      </div>
      <div *ngIf="ctrl.conversations.length === 0" class="conv-empty">
        Sin conversaciones previas
      </div>
    </div>

    <!-- Mensajes -->
    <div #widgetChat class="agent-chat-messages">
      <!-- Welcome -->
      <div *ngIf="ctrl.messages.length === 0 && !ctrl.isLoading" class="welcome-msg">
        <img src="assets/img/aguacatebot.png" alt="Aguacatico" class="welcome-avatar" />
        <p class="welcome-text">Hola! Soy <strong>Aguacatico</strong>, tu asistente AI.</p>
        <p class="welcome-sub">Preguntame sobre transacciones, tasas, saldos, analytics y mas.</p>
        <div class="welcome-suggestions">
          <button class="suggestion-chip" (click)="inputMessage = 'Cuantas transacciones hubo hoy?'; sendMessage()">
            Transacciones hoy
          </button>
          <button class="suggestion-chip" (click)="inputMessage = 'Cual es la tasa actual?'; sendMessage()">
            Tasa actual
          </button>
          <button class="suggestion-chip" (click)="inputMessage = 'Top 5 usuarios por volumen esta semana'; sendMessage()">
            Top usuarios
          </button>
        </div>
      </div>

      <!-- Loading -->
      <div *ngIf="ctrl.isLoading" class="loading-container">
        <mat-spinner diameter="28"></mat-spinner>
      </div>

      <!-- Chat messages -->
      <ng-container *ngIf="!ctrl.isLoading">
        <div *ngFor="let msg of ctrl.messages" class="msg-wrapper" [ngClass]="'msg-' + msg.role">
          <!-- User -->
          <div *ngIf="msg.role === 'user'" class="msg-bubble msg-user">
            {{ msg.content }}
          </div>

          <!-- Assistant -->
          <div *ngIf="msg.role === 'assistant'" class="msg-bubble msg-assistant">
            <div class="msg-text">{{ msg.content }}</div>
            <div *ngIf="msg.usage" class="msg-usage">
              {{ msg.usage.inputTokens + msg.usage.outputTokens }} tokens
              <span *ngIf="msg.usage.estimatedCostUsd">
                ~ ${{ msg.usage.estimatedCostUsd.toFixed(4) }}
              </span>
            </div>
          </div>

          <!-- Tool -->
          <div *ngIf="msg.role === 'tool'" class="msg-tool">
            <mat-icon>build_circle</mat-icon>
            <span>{{ msg.content }}</span>
          </div>

          <!-- Error -->
          <div
            *ngIf="msg.role === 'error'"
            class="msg-bubble msg-error"
            [class.msg-rate-limited]="msg.rateLimited"
          >
            <mat-icon>{{ msg.rateLimited ? 'hourglass_top' : 'error_outline' }}</mat-icon>
            {{ msg.content }}
          </div>
        </div>

        <!-- Streaming -->
        <div *ngIf="ctrl.isStreaming" class="msg-wrapper msg-assistant">
          <div *ngIf="ctrl.thinkingText && !ctrl.streamingText" class="msg-thinking">
            <mat-spinner diameter="14"></mat-spinner>
            <span>Analizando...</span>
          </div>
          <div *ngIf="ctrl.streamingText" class="msg-bubble msg-assistant">
            <div class="msg-text">{{ ctrl.streamingText }}</div>
            <span class="streaming-dot"></span>
          </div>
          <div *ngIf="!ctrl.streamingText && !ctrl.thinkingText" class="msg-thinking">
            <mat-spinner diameter="14"></mat-spinner>
            <span>{{ deepMode ? 'Análisis profundo...' : 'Pensando...' }}</span>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Input -->
    <div class="agent-chat-input">
      <textarea
        [(ngModel)]="inputMessage"
        (keydown)="onKeyDown($event)"
        [disabled]="ctrl.isStreaming"
        [placeholder]="deepMode ? 'Consulta compleja...' : 'Escribe tu consulta...'"
        rows="1"
      ></textarea>
      <button
        *ngIf="!ctrl.isStreaming"
        class="send-btn"
        [disabled]="!inputMessage.trim()"
        (click)="sendMessage()"
      >
        <mat-icon>send</mat-icon>
      </button>
      <button
        *ngIf="ctrl.isStreaming"
        class="stop-btn"
        (click)="stopStreaming()"
      >
        <mat-icon>stop</mat-icon>
      </button>
    </div>
  </div>

  <!-- Burbuja FAB Aguacatico -->
  <button class="agent-fab" (click)="toggleChat()" [class.open]="isOpen">
    <img *ngIf="!isOpen" src="assets/img/aguacatebot.png" alt="Aguacatico" class="fab-icon" />
    <mat-icon *ngIf="isOpen">close</mat-icon>
  </button>
</div>
